import { BannerContext } from '#pplx/frontend/aether/components/Banner/useBannerContext.js';
export const BannerProvider = BannerContext.Provider;
//# sourceMappingURL=BannerContext.js.map